export enum BatchTabs {
    VIEW = "View Batches",
    CREATE = "Create New Batch",
    ARCHIVED = "Archived Batches",
    KINSHIPSEARCH = "Search",
    CARRIERSEARCH = "Search Patients",
    CARRIEROUSTANDING = "Outstanding",
    COMPWELLNESS_SEARCH = "Search Patients",
    COMPWELLNESS_OUTSTANDING = "Outstanding",
    LUMIWELLNESS_SEARCH = "Search Patients",
    LUMIWELLNESS_OUTSTANDING = "Outstanding",
}